import BaseRepository from '@/api/repositories/BaseRepository';

export default class UserNotificationSettingsRepository extends BaseRepository {
	getSettings() {
		return this.get('notificationSettings', {});
	}

	updateSettings(data) {
		return this.post('notificationSettings', {}, data);
	}
}
